if (typeof RecentlyViewedProducts !== 'function') {
	class RecentlyViewedProducts extends HTMLElement {
		constructor() {
			super();
			this.localStorageKey = 'RecentlyViewedProducts';
			this.limit = this.dataset.limit;
			this.sectionId = this.id;
		}

		connectedCallback() {
			const productId = this.getAttribute('data-product-id');

			if (productId) {
				this.trackProduct(productId);
			}

			new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
		}

		trackProduct(productId) {
			let storedProducts = this.getRecentlyViewed();

			const currentProduct = `id:${productId}`;
			const productIndex = storedProducts.indexOf(currentProduct);

			if (productIndex > -1) {
				storedProducts.splice(productIndex, 1);
			}

			if (storedProducts.length >= this.limit) {
				storedProducts.pop();
			}

			storedProducts.unshift(currentProduct);

			localStorage.setItem(this.localStorageKey, storedProducts.join(','));
		}

		getRecentlyViewed() {
			const storedProducts = localStorage.getItem(this.localStorageKey);
			return storedProducts ? storedProducts.split(',') : [];
		}

		handleIntersection(entries, observer) {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			const storedProducts = this.getRecentlyViewed();

			if (storedProducts.length === 0) {
				return;
			}

			const query = storedProducts.join('%20OR%20');
			const searchUrl = `/search?section_id=${this.sectionId}&type=product&q=${query}`;

			fetch(searchUrl)
				.then((response) => response.text())
				.then((text) => {
					const innerHTML = new DOMParser()
						.parseFromString(text, 'text/html')
						.querySelector('recently-viewed-products');

					if (innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0) {
						this.innerHTML = innerHTML.innerHTML;

						this.dispatchEvent(new Event('recentlyViewedProducts:success'));
					} else {
						this.dispatchEvent(new Event('recentlyViewedProducts:fail'));
					}
				})
				.catch((e) => {
					console.error('Error loading recently viewed products:', e);
					this.dispatchEvent(new Event('recentlyViewedProducts:fail'));
				});
		}
	}

	if (typeof customElements.get('recently-viewed-products') == 'undefined') {
		customElements.define('recently-viewed-products', RecentlyViewedProducts);
	}
}